import PubSub from 'pubsub-js'

import { FEEDBACK_OPEN } from 'features/feedback/pubsub'

export const FOXFORD_MENU_ITEMS = [
  {
    link: '/about',
    text: 'О Фоксфорде',
    routeMatches: true,
  },
  {
    link: '/teachers',
    text: 'Наши преподаватели',
    routeMatches: true,
  },
  {
    link: '/reviews',
    text: 'Отзывы о Фоксфорде',
    routeMatches: true,
  },
  {
    link: '/partner_promo',
    text: 'Партнерская программа',
    routeMatches: false,
  },
  {
    link: '/contacts',
    text: 'Контакты',
    routeMatches: true,
  },
  {
    link: 'https://foxford.ru/jobs',
    text: 'Вакансии',
    attributes: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  },
  {
    link: 'https://design.foxford.ru/branding',
    text: 'Логотипы Фоксфорда',
  },
  {
    text: 'Обратная связь',
    onClickHandler: () => PubSub.publish(FEEDBACK_OPEN),
    hideOnExternal: true,
  },
  {
    link: '/legal/general',
    text: 'Правовая информация',
  },
  {
    link: 'https://netology-group.ru/official_info',
    text: 'Сведения об образовательной <br /> организации',
    attributes: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  },
]

export const STUDY_MENU_ITEMS_TEACHERS = [
  {
    link: '/catalog/courses',
    text: 'Курсы',
    routeMatches: true,
  },
  {
    link: '/coach/landing',
    text: 'Репетиторы',
    routeMatches: true,
  },
  {
    link: (isAgent) => (isAgent ? '/catalog/teacher' : 'https://teacher.foxford.ru/'),
    text: 'Учителю',
    routeMatches: (isAgent) => !!isAgent,
  },
  {
    link: '/o',
    text: 'Олимпиады и конкурсы',
    routeMatches: false,
  },
  {
    link: 'https://externat.foxford.ru',
    text: 'Домашняя школа',
  },
  {
    link: 'https://media.foxford.ru',
    text: 'Полезное',
  },
  {
    link: '/wiki',
    text: 'Учебник',
  },
  {
    link: '/levels/ege',
    text: 'Подготовка к ЕГЭ',
  },
  {
    link: '/levels/oge',
    text: 'Подготовка к ОГЭ',
  },
  {
    link: '/levels/olympiads',
    text: 'Подготовка к олимпиадам',
  },
  {
    link: '/catalog/trainings',
    text: 'Онлайн-тесты',
  },
  {
    link: 'https://training.foxford.ru',
    text: 'Пробные ЕГЭ',
  },
]

export const STUDY_MENU_ITEMS = [
  {
    link: '/catalog/courses',
    text: 'Курсы',
    routeMatches: true,
  },
  {
    link: '/coach/landing',
    text: 'Репетиторы',
    routeMatches: true,
  },
  {
    link: (isAgent) => (isAgent ? '/catalog/teacher' : 'https://teacher.foxford.ru'),
    text: 'Учителю',
    routeMatches: (isAgent) => !!isAgent,
  },
  {
    link: '/o',
    text: 'Олимпиады и конкурсы',
    routeMatches: false,
  },
  {
    link: 'https://externat.foxford.ru/',
    text: 'Домашняя школа',
  },
  {
    link: 'https://media.foxford.ru',
    text: 'Полезное',
  },
  {
    link: '/wiki',
    text: 'Учебник',
  },
  {
    link: '/levels/ege',
    text: 'Подготовка к ЕГЭ',
  },
  {
    link: '/levels/oge',
    text: 'Подготовка к ОГЭ',
  },
  {
    link: '/levels/olympiads',
    text: 'Подготовка к олимпиадам',
  },
  {
    link: '/catalog/trainings',
    text: 'Онлайн-тесты',
  },
  {
    link: 'https://training.foxford.ru',
    text: 'Пробные ЕГЭ',
  },
]

export const SOCIAL_LINKS = [
  {
    href: 'https://vk.com/foxford_edu',
    icon: 'iconVk',
    title: 'Группа для учеников',
  },
  {
    href: 'https://vk.com/foxford_for_parents',
    icon: 'iconVkInserse',
    title: 'Группа для родителей',
  },
  {
    href: 'https://www.facebook.com/foxford.ru',
    icon: 'iconFacebook',
    title: 'Фоксфорд в Facebook',
  },
  {
    href: 'https://ok.ru/foxfordege',
    icon: 'iconOk',
    title: 'Фоксфорд в Одноклассниках',
  },
  {
    href: 'https://www.youtube.com/foxfordru',
    icon: 'iconYoutube',
    title: 'Наш канал в YouTube',
  },
  {
    href: 'https://instagram.com/foxford_edu',
    icon: 'iconInstagram',
    title: 'Фоксфорд в Instagram',
  },
]

export const SOCIAL_LINKS_FOR_TEACHERS = [
  {
    href: 'https://vk.com/courses_for_teachers',
    icon: 'iconVk',
    title: 'Группа для учителей',
  },
  {
    href: 'https://www.facebook.com/foxford.ru',
    icon: 'iconFacebook',
    title: 'Фоксфорд в Facebook',
  },
  {
    href: 'https://ok.ru/kursypovy',
    icon: 'iconOk',
    title: 'Фоксфорд в Одноклассниках',
  },
  {
    href: 'https://www.youtube.com/foxfordru',
    icon: 'iconYoutube',
    title: 'Наш канал в YouTube',
  },
  {
    href: 'https://instagram.com/foxford_edu',
    icon: 'iconInstagram',
    title: 'Фоксфорд в Instagram',
  },
]
